import React from "react";
import classnames from "classnames";
import style from "./style.module.scss";

interface Props {
    icon?: string;
    alt?: string;
    className?: string;
}

export const PodcastIcon = (props: Props): JSX.Element => {
    const { icon, alt, className, ...other } = props;

    return (
        <div className={classnames(style.icon, className)}>
            <img src={icon} alt=""></img>
            <img className={classnames(style.gray)} src={`${icon}_gray`} alt={alt} {...other}></img>
        </div>
    );
};
